export const playgroundEvaluateMutationKeys = {
  sheetReferenceUpdate: (workspaceId: number, sessionId: string) =>
    ["playground", "evaluate", "sheet-reference-update", workspaceId, sessionId] as const,
};

export const playgroundEvaluateQueryKeys = {
  state: (workspaceId: number, sessionId: string) =>
    ["playground", "evaluate", workspaceId, sessionId] as const,

  run: (workspaceId: number, sessionId: string, runId: string) =>
    ["playground", "evaluate", "run", workspaceId, sessionId, runId] as const,
  sheetGrid: (workspaceId: number, tableId: string, sheetId: string, limit: number) =>
    ["playground", "evaluate", "sheet-grid", workspaceId, tableId, sheetId, limit] as const,
};
